import { gql } from "@apollo/client";

const GET_ADJUNTOS_RECLAMO = gql`
query archivosReclamo ( $idGestionReclamo: Int!) {
    archivosReclamo( idGestionReclamo: $idGestionReclamo ){
        idDocumentoReclamo
        idGestionReclamo
        idUsuarioAlta
        fechaAlta
        titulo
        extension
        archivo
        contentType
        fechaAlta
        usuarioNombre
    }
}
`;
export default GET_ADJUNTOS_RECLAMO;

export const adaptAdjuntosReclamoArray = (reclamos) => {
  return structuredClone(reclamos)?.map((reclamo) => adaptAdjuntoReclamo(reclamo));
};
const adaptAdjuntoReclamo = (reclamo) => {
  return {
    idArchivo: reclamo?.idDocumentoReclamo,
    idGestionReclamo: reclamo?.idGestionReclamo,
    idUsuario: reclamo?.idUsuarioAlta,
    usuario: reclamo?.usuarioNombre,
    fechaAlta: reclamo?.fechaAlta,
    titulo: reclamo?.titulo,
    extension: reclamo?.extension,
    archivo: reclamo?.archivo,
    contentType: reclamo?.contentType
  };
};